import { z } from "zod";

export const connectDevicesToProviderPayloadSchema = z.object({
  data: z.array(
    z.object({
      vehicleUuid: z.uuid(),
      registrationNumber: z.string(),
      deviceId: z.string(),
      updatedBy: z.string(),
    }),
  ),
});

export type ConnectDevicesToProviderPayload = z.infer<
  typeof connectDevicesToProviderPayloadSchema
>;
